import { request } from "./request";

// 获取机构列表
function getOrListAPI(data) {
    return request({
        url: '/sys/org/selectListPage',
        method: 'POST',
        data: data
    })
}

//导出
function exportOrgAPI(data) {
    return request({
        url: '/sys/org/exportData',
        method: 'POST',
        responseType: 'blob',
        data: data,
    })
}

// 删除
function orgDeleteAPI(data) {
    return request({
        url: '/sys/org/orgDelete',
        method: 'POST',
        data: data
    })
}

// 修改
function orgAddAPI(data) {
    return request({
        url: '/sys/org/orgSave',
        method: 'POST',
        data: data
    })
}

// 查看
function orgUpdateAPI(data) {
    return request({
        url: '/sys/org/getOrg',
        method: 'POST',
        data: data
    })
}






export default {
    getOrListAPI,
    exportOrgAPI,
    orgDeleteAPI,
    orgAddAPI,
    orgUpdateAPI,
}
